// extracted by mini-css-extract-plugin
module.exports = {"container":"Parts_container__BErz_","title":"Parts_title__N_MoH"};